import { render, staticRenderFns } from "./DocContent.vue?vue&type=template&id=023b1c72&"
import script from "./DocContent.vue?vue&type=script&lang=js&"
export * from "./DocContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports